var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "both-pd-box" },
    [
      _c(
        "div",
        {
          staticStyle: {
            background: "#fff",
            padding: "30px",
            "border-radius": "20px",
          },
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "基础信息", name: "1" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm11",
                      staticClass: "demo-ruleForm",
                      staticStyle: { width: "60%" },
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "150px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "APP名称", prop: "" } },
                        [
                          _c("el-input", {
                            attrs: { readonly: true, disabled: "" },
                            model: {
                              value: _vm.ruleForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "name", $$v)
                              },
                              expression: "ruleForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { label: "APP主色", prop: "" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      autocomplete: "off",
                                    },
                                    model: {
                                      value: _vm.ruleForm.mainColor,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "mainColor", $$v)
                                      },
                                      expression: "ruleForm.mainColor",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-color-picker", {
                                    attrs: { "show-alpha": "" },
                                    model: {
                                      value: _vm.ruleForm.mainColor,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "mainColor", $$v)
                                      },
                                      expression: "ruleForm.mainColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { label: "主色对应文字色", prop: "" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.ruleForm.mainFontColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "mainFontColor",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.mainFontColor",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-color-picker", {
                                    model: {
                                      value: _vm.ruleForm.mainFontColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "mainFontColor",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.mainFontColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { label: "APP辅色", prop: "" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.ruleForm.salveColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "salveColor",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.salveColor",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-color-picker", {
                                    model: {
                                      value: _vm.ruleForm.salveColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "salveColor",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.salveColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "50%" },
                              attrs: { label: "辅色对应文字色", prop: "" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.ruleForm.salveFontColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "salveFontColor",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.salveFontColor",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-color-picker", {
                                    model: {
                                      value: _vm.ruleForm.salveFontColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "salveFontColor",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.salveFontColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "APP图标", prop: "icon" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "148px",
                                height: "148px",
                                background: "#f9f9f9",
                                "border-radius": "4px",
                                border: "1px solid #eeeeee",
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    "show-file-list": false,
                                    action: "",
                                    "http-request": function (value) {
                                      return _vm.handleFileUpload(value, "icon")
                                    },
                                  },
                                },
                                [
                                  _vm.ruleForm.icon
                                    ? _c("img", {
                                        staticClass: "avatar_img",
                                        attrs: { src: _vm.ruleForm.icon },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v(
                              "180*180PNG(图标应用的位置:登录页、首页底部登录条)"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "APP预加载图" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "148px",
                                height: "148px",
                                background: "#f9f9f9",
                                "border-radius": "4px",
                                border: "1px solid #eeeeee",
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    "show-file-list": false,
                                    action: "",
                                    "http-request": function (value) {
                                      return _vm.handleFileUpload(
                                        value,
                                        "preloadedImage"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.ruleForm.preloadedImage
                                    ? _c("img", {
                                        staticClass: "avatar_img",
                                        attrs: {
                                          src: _vm.ruleForm.preloadedImage,
                                        },
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v(
                              "建议尺寸256*256 PNG图片(商品信息加载前展示)"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { label: "置顶图标", prop: "topIcon" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "148px",
                                height: "148px",
                                background: "#f9f9f9",
                                "border-radius": "4px",
                                border: "1px solid #eeeeee",
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    "show-file-list": false,
                                    action: "",
                                    "http-request": function (value) {
                                      return _vm.handleFileUpload(
                                        value,
                                        "topIcon"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.ruleForm.topIcon
                                    ? _c("img", {
                                        staticClass: "avatar_img",
                                        attrs: { src: _vm.ruleForm.topIcon },
                                      })
                                    : _c("img", {
                                        staticClass: "avatar_img",
                                        attrs: {
                                          src: require("@/assets/TopStory.png"),
                                        },
                                      }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v(
                              "所有涉及“置顶图标”的地方，都需要展示该图标，建议尺寸120*120 PNG图片"
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "首页展示模板", prop: "pageCode" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm.pageCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "pageCode", $$v)
                                },
                                expression: "ruleForm.pageCode",
                              },
                            },
                            _vm._l(_vm.templateList, function (item) {
                              return _c("el-option", {
                                key: item.pageCode,
                                attrs: {
                                  label: item.pageName,
                                  value: item.pageCode,
                                },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v("App首页需要向用户展示的模板，模板可在【"),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#66b1ff",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openGoodsList("home")
                                  },
                                },
                              },
                              [_vm._v("首页装修")]
                            ),
                            _vm._v("】内进行配置"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "个人中心展示模板",
                            prop: "personalPageCode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.ruleForm.personalPageCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "personalPageCode",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.personalPageCode",
                              },
                            },
                            _vm._l(_vm.userCenterList, function (item) {
                              return _c("el-option", {
                                key: item.pageCode,
                                attrs: {
                                  label: item.pageName,
                                  value: item.pageCode,
                                },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v("App首页需要向用户展示的模板，模板可在【"),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#66b1ff",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openGoodsList("userCenter")
                                  },
                                },
                              },
                              [_vm._v("个人中心装修")]
                            ),
                            _vm._v("】内进行配置"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-top": "30px" },
                          attrs: { label: "用户协议", prop: "license" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { readonly: true, clearable: "" },
                                model: {
                                  value: _vm.ruleForm.license,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "license", $$v)
                                  },
                                  expression: "ruleForm.license",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: { type: "primary", plain: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.bothBuff({
                                        key: "license",
                                        title: "用户协议",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("管理")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-top": "30px" },
                          attrs: { label: "隐私政策", prop: "privacy" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { readonly: true, clearable: "" },
                                model: {
                                  value: _vm.ruleForm.privacy,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "privacy", $$v)
                                  },
                                  expression: "ruleForm.privacy",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: { type: "primary", plain: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.bothBuff({
                                        key: "privacy",
                                        title: "隐私政策",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("管理")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-top": "30px" },
                          attrs: {
                            label: "APP全局搜索框文字",
                            prop: "searchText",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.ruleForm.searchText,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "searchText", $$v)
                              },
                              expression: "ruleForm.searchText",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-top": "30px" },
                          attrs: { label: "官方热词", prop: "" },
                        },
                        [
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.ruleForm.hotkeyStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "hotkeyStatus", $$v)
                              },
                              expression: "ruleForm.hotkeyStatus",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v(
                              "热词打开后，首页搜索框内会滚动展示官方热门商品搜索提示词"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-top": "30px" },
                          attrs: { label: "二合一下载地址" },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.ruleForm.downloadLink,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "downloadLink", $$v)
                              },
                              expression: "ruleForm.downloadLink",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v(
                              "腾讯应用宝的二合一下载地址，在腾讯开放平台应用宝开放平台内获取（注意APP需先上架至应用宝和APPstore）"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { staticStyle: { "margin-top": "60px" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "200px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("ruleForm11")
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "接口域名配置", name: "2" } },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "demo-ruleForm",
                      staticStyle: { width: "60%" },
                      attrs: { "label-width": "150px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "域名白名单", prop: "" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "800px" },
                            attrs: {
                              placeholder: "请输入",
                              autosize: "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.domainList,
                              callback: function ($$v) {
                                _vm.domainList = $$v
                              },
                              expression: "domainList",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "tips",
                              staticStyle: { color: "rgb(245, 154, 35)" },
                            },
                            [
                              _vm._v(
                                "请在此填写允许调用接口的网站域名(例如:baidu.com)每个域名之间请换行填写"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { staticStyle: { "margin-top": "60px" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "200px" },
                              attrs: { type: "primary" },
                              on: { click: _vm.setList },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("basePagePop", { ref: "basePagePop" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }